import { NavLink } from 'react-router-dom';
import type { AgentsNavGroup } from './agents-nav.types';
import styles from './AgentsNavLinkGroup.module.css';

interface AgentsNavLinkGroupProps {
  group: AgentsNavGroup;
}

export const AgentsNavLinkGroup = ({ group }: AgentsNavLinkGroupProps) => {
  const { heading, links } = group;

  return (
    <section className={styles.group}>
      {heading && <h3>{heading}</h3>}
      <ul>
        {links.map(link => (
          <li key={link.to}>
            <NavLink to={link.to} end={link.matchesExactly}>
              {link.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </section>
  );
};
